import React from 'react';

import { static_payment_policy_path, static_terms_path } from '../../../../routes';
import styles from './styles.module.scss';

const CANCELLATION_INSTRUCTIONS_URL =
  'https://theinformation.zendesk.com/hc/en-us/articles/218193188-Cancel-subscription';

const Disclosure = () => (
  <div className="row">
    <div className="col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
      <div className={styles.subscribePrivacyTermsandConditions}>
        <span className="fa fa-lock"></span>
        <div>We value your privacy and security</div>
        <div className="mt1">
          By clicking “Subscribe” you agree to our{' '}
          <a target="_blank" rel="noreferrer" href={static_terms_path}>
            Terms of Service
          </a>{' '}
          and our{' '}
          <a target="_blank" rel="noreferrer" href={static_payment_policy_path}>
            Payment Policy
          </a>
          . Subscriptions will automatically renew{' '}
          <a target="_blank" rel="noreferrer" href={CANCELLATION_INSTRUCTIONS_URL}>
            until canceled
          </a>
          . Prices are subject to change. This site is protected by reCAPTCHA and the Google Privacy
          Policy and Terms of Service apply.
        </div>
      </div>
    </div>
  </div>
);

export default Disclosure;
